import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Space, Table } from 'antd';
import Title from 'antd/lib/typography/Title';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import menuApi from '../../api/menu';
import SH_Toolbar from '../../components/SH_Toolbar';
import pagesApi from './../../api/page';
import TV_menu_detail from './TV_menu_detail';

const TV_menu = () => {
	const [dictionary, setDictionary] = useState({ pages: [] });
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [total, setTotal] = useState(0);
	const refDetail = useRef();

	const [filter, setFilter] = useState({
		page: 1,
		limit: 10,
		search: '',
	});

	useEffect(() => {
		getMenus({ page: 1, limit: 10 });
		getCategory().then(() => null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getCategory = async () => {
		setLoading(true);
		try {
			const [pages] = await Promise.all([
				pagesApi.get({
					page: 1,
					limit: 99999,
				}),
			]);

			setDictionary({
				pages: pages?.data?.data?.items?.map((x) => ({ ...x, label: x?.names?.vi })) || [],
			});
		} finally {
			setLoading(false);
		}
	};

	const getMenus = (_filter) => {
		const next = {
			...filter,
			page: _filter?.page || filter.page || 1,
			limit: _filter?.limit || filter.limit || 10,
			search: _filter?.search ?? filter.search ?? '',
		};

		setLoading(true);
		menuApi
			.get(next)
			.then((res) => {
				setProducts(res?.data?.data?.items || []);
				setTotal(res?.data?.data?.pagination?.total || 0);
			})
			.finally(() => setLoading(false));

		setFilter(next);
	};

	const conFirm = (record) => {
		return Modal.confirm({
			title: 'Xác nhận xóa',
			content: 'Bạn có chắc chắn muốn xóa bản ghi này không ? ',
			onOk: () => deleteItem(record),
			footer: (_, { OkBtn, CancelBtn }) => (
				<>
					<CancelBtn />
					<OkBtn />
				</>
			),
		});
	};

	const deleteItem = (record) => {
		setLoading(true);
		menuApi
			.delete(record._id)
			.then(() => getMenus({ page: filter.page, limit: filter.limit, search: filter.search }))
			.finally(() => setLoading(false));
	};

	const showModal = () => {
		refDetail.current?.create();
	};

	const handlePageChange = (page, pageSize) => {
		getMenus({
			page,
			limit: pageSize,
			search: filter.search,
		});
	};

	const columns = [
		{
			title: 'Key',
			dataIndex: 'key',
			key: 'key',
			render: (text) => <span>{text}</span>,
		},
		{
			title: 'Tổng số mục đã bật',
			dataIndex: 'totalEnabledItems',
			key: 'totalEnabledItems',
			render: (text) => <span>{text}</span>,
		},
		{
			title: 'Tổng số mục',
			dataIndex: 'totalItems',
			key: 'totalItems',
			render: (totalItems) => totalItems,
		},
		{
			title: 'Ngày tạo',
			dataIndex: 'createdAt',
			key: 'createdAt',
			render: (createdAt) => <span>{createdAt ? dayjs(createdAt).format('HH:mm A DD/MM/YYYY') : ''}</span>,
			sorter: (a, b) => dayjs(a.createdAt).isAfter(dayjs(b.createdAt)),
			sortDirections: ['descend'],
		},
		{
			title: 'Thao tác',
			key: 'action',
			render: (_, record) => {
				console.log({ record });
				return (
					<Space size="middle">
						<Button onClick={() => refDetail.current?.update(record)} icon={<EditOutlined />}>
							Sửa
						</Button>
						<Button onClick={() => conFirm(record)} type="dashed" danger icon={<DeleteOutlined />}>
							Xoá
						</Button>
					</Space>
				);
			},
		},
	];

	return (
		<>
			<Title level={2}>Menu</Title>

			<SH_Toolbar
				left={() => (
					<Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
						Thêm Menu
					</Button>
				)}
				right={() => (
					<Input.Search
						style={{ width: 240 }}
						placeholder="Nhập key menu..."
						allowClear
						onChange={(e) => getMenus({ page: 1, limit: filter.limit, search: e.target.value })}
						onSearch={(v) => getMenus({ page: 1, limit: filter.limit, search: v })}
					/>
				)}
			/>

			<Table
				className="mt-2"
				loading={loading}
				columns={columns}
				dataSource={products}
				rowKey="_id"
				pagination={{
					current: filter.page,
					pageSize: filter.limit,
					total,
					onChange: handlePageChange,
					showSizeChanger: true
				}}
				scroll={{ x: 1300 }}
			/>

			<TV_menu_detail ref={refDetail} getMenus={getMenus} pages={dictionary.pages} />
		</>
	);
};

export default TV_menu;
